module.exports = __webpack_public_path__ + "img/s2.38b84dc8.jpg";